import {Bm} from '../graphql/generated/types';
import {BmTypeStr} from './TrackEventObject.interface';

export const BM_TO_BM_type_MAP: {[key in Bm]: BmTypeStr} = {
  [Bm.Free]: '무료',
  [Bm.FreePreview]: '무료_미리보기',
  [Bm.Pay]: '유료',
  [Bm.PayWaitfree]: '유료_기다무',
  [Bm.MixedPay]: '복합_유료',
  [Bm.MixedWaitfree]: '복합_기다무',
};

/**
 * 특정 브릿지 페이지(빌링)은 KPApp 에 trackEvent 를 넣어줍니다.
 * 외부에서 앱으로 띄우든 앱으로 띄우든 상관 없이 일관되게 트래킹할 수 있도록 하기 위함입니다
 * 해당 KPApp 은 웹뷰인 경우 앱이, 웹인 경우 웹이 주입합니다
 */
export const INJECT_TRACKEVENT_HTML = `<script type="text/javascript">
    window.KPApp = { trackEvent : window.opener.KPWeb.trackEvent } ;
    </script>`;

export const TRACK_JS_PATH = '/track.js';

export const TIARA_OBJECT_PROPS_KEY = 'data-t-obj';

export const GA_TRACKER_NAME = 'pageweb_tracker';
export const GA_TRACKING_CODE = 'G-EGMMPXGJS3';
